import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PainterDewaterkant() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  const painter = {
    id: "painters-dewaterkant",
    name: "Painters De Waterkant",
    location: "De Waterkant, Cape Town",
    rating: 4.9,
    reviews: 167,
    specialties: ["Urban Apartments", "Heritage Properties", "Interior Design", "Commercial Spaces"],
    image: "https://public.readdy.ai/ai/img_res/94a15424193e957176c2b1bdc22b3cd2.jpg",
    verified: true,
    yearsExperience: 16,
    website: "https://paintersdewaterkant.co.za",
    email: "info@paintersdewaterkant.co.za",
    description: "Professional painting services in De Waterkant and surrounding urban areas. We specialize in apartment complexes, heritage properties, and commercial spaces with expertise in modern finishes and historical restoration work.",
    services: [
      "Interior Apartment Painting",
      "Exterior Building Painting", 
      "Heritage Property Restoration",
      "Commercial Space Painting",
      "Decorative Finishes",
      "Waterproofing Services",
      "Damp Proofing Solutions",
      "Color Consultation & Design"
    ],
    serviceAreas: ["De Waterkant", "Green Point", "Sea Point", "Waterfront", "City Bowl", "Bo-Kaap", "Gardens", "Tamboerskloof"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Beautiful%20interior%20living%20room%20painted%20by%20professional%20painters%20in%20De%20Waterkant%2C%20modern%20urban%20apartment%20with%20fresh%20white%20walls%2C%20quality%20paint%20finish%2C%20Signal%20Hill%20view%2C%20bright%20natural%20lighting%2C%20clean%20professional%20painting%20work%2C%20contemporary%20design&width=400&height=300&seq=dewaterkant-gallery-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20building%20painting%20project%20in%20De%20Waterkant%20Cape%20Town%2C%20heritage%20apartment%20building%20with%20fresh%20paint%2C%20professional%20painters%20working%2C%20quality%20exterior%20finish%2C%20urban%20setting%20with%20mountain%20view%2C%20well-maintained%20property&width=400&height=300&seq=dewaterkant-gallery-2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Commercial%20space%20painting%20project%20in%20De%20Waterkant%2C%20professional%20painters%20working%20on%20trendy%20office%20interior%2C%20quality%20commercial%20paint%20finish%2C%20modern%20urban%20architecture%2C%20organized%20work%20site&width=400&height=300&seq=dewaterkant-gallery-3&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Kitchen%20interior%20painting%20in%20De%20Waterkant%20urban%20apartment%2C%20fresh%20painted%20walls%2C%20modern%20kitchen%20design%2C%20quality%20paint%20finish%2C%20bright%20clean%20space%2C%20professional%20painting%20work&width=400&height=300&seq=dewaterkant-gallery-4&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Heritage%20property%20restoration%20painting%20in%20De%20Waterkant%2C%20professional%20painters%20working%20on%20Victorian%20building%20exterior%2C%20quality%20restoration%20finish%2C%20historical%20architecture%2C%20careful%20preservation%20work&width=400&height=300&seq=dewaterkant-gallery-5&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Bedroom%20interior%20painting%20in%20De%20Waterkant%20apartment%2C%20fresh%20painted%20walls%2C%20modern%20bedroom%20design%2C%20quality%20paint%20finish%2C%20bright%20clean%20space%2C%20professional%20painting%20work%2C%20urban%20living&width=400&height=300&seq=dewaterkant-gallery-6&orientation=landscape"
    ],
    testimonials: [
      {
        name: "Michael Anderson",
        rating: 5,
        comment: "Exceptional work on our De Waterkant apartment. The team was professional, clean, and the finish is absolutely perfect. They understood the urban environment and worked efficiently around our schedule."
      },
      {
        name: "Sophie van Niekerk", 
        rating: 5,
        comment: "Outstanding service from start to finish. They completed our heritage building painting with great attention to detail and respect for the historical features. Highly recommend for De Waterkant properties."
      },
      {
        name: "James Peterson",
        rating: 5,
        comment: "Professional painters who truly understand urban apartment living. They were clean, efficient, and the quality of work exceeded our expectations. Our apartment looks stunning."
      }
    ]
  };

  useEffect(() => {
    document.title = "Painters De Waterkant | Professional Urban Painting Services Cape Town | Apartment Specialists";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Painters De Waterkant offers professional painting services for urban apartments and heritage properties in De Waterkant, Cape Town. Specializing in modern finishes, apartment complexes, and commercial spaces. Get a free quote today.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Painters De Waterkant, apartment painters Cape Town, urban painting contractors, heritage property painting, commercial painting services');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-96 bg-gradient-to-r from-blue-600 to-blue-800">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20stylish%20urban%20apartment%20building%20in%20De%20Waterkant%20Cape%20Town%2C%20trendy%20neighborhood%20with%20Signal%20Hill%20and%20Table%20Mountain%20views%2C%20painters%20in%20clean%20uniforms%20with%20modern%20equipment%2C%20contemporary%20architecture%20mixed%20with%20Victorian%20heritage%20buildings%2C%20bright%20natural%20lighting%2C%20high%20quality%20urban%20residential%20painting%20project&width=1200&height=600&seq=dewaterkant-painters-hero&orientation=landscape)` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
          <div className="text-white">
            <div className="flex items-center mb-4">
              <h1 className="text-4xl md:text-5xl font-bold mr-4">{painter.name}</h1>
              {painter.verified && (
                <div className="bg-green-500 text-white px-3 py-1 rounded-full text-sm font-semibold flex items-center">
                  <i className="ri-shield-check-line mr-1"></i>
                  Verified
                </div>
              )}
            </div>
            
            <p className="text-xl mb-4 flex items-center">
              <i className="ri-map-pin-line mr-2"></i>
              {painter.location}
            </p>
            
            <div className="flex items-center space-x-6 mb-6">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`ri-star-fill ${i < Math.floor(painter.rating) ? 'text-yellow-400' : 'text-gray-400'}`}></i>
                ))}
                <span className="ml-2">{painter.rating} ({painter.reviews} reviews)</span>
              </div>
              <span>{painter.yearsExperience} years experience</span>
            </div>
            
            <div className="flex space-x-4">
              <button 
                onClick={() => navigate('/quote')}
                className="bg-lime-400 text-black px-6 py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                Get Free Quote
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Navigation Tabs */}
      <section className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex space-x-8">
            {[
              { id: 'overview', label: 'Overview' },
              { id: 'services', label: 'Services' },
              { id: 'gallery', label: 'Gallery' },
              { id: 'reviews', label: 'Reviews' },
              { id: 'contact', label: 'Contact' }
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer ${
                  activeTab === tab.id
                    ? 'border-lime-500 text-lime-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </section>

      {/* Content Sections */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {activeTab === 'overview' && (
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Professional Painting Services in De Waterkant</h2>
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                  {painter.description}
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Urban Painting Specialists in Cape Town's Trendiest Neighborhood</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  De Waterkant has transformed into one of Cape Town's most vibrant and sought-after urban neighborhoods, known for its unique blend of Victorian heritage architecture and contemporary design. Our team has over 16 years of specialized experience working in this dynamic area, understanding the unique requirements of urban apartment living, heritage property restoration, and commercial space transformation. We've built our reputation on delivering exceptional painting services that respect the historical character of De Waterkant while embracing modern design trends and finishes.
                </p>
                
                <p className="text-gray-700 leading-relaxed mb-6">
                  The De Waterkant area presents unique challenges for painting contractors. From narrow cobblestone streets that require careful logistics planning to heritage buildings with strict preservation requirements, our team has the expertise and experience to handle every aspect of urban painting projects. We understand the importance of minimizing disruption in densely populated areas and work efficiently to complete projects on schedule while maintaining the highest quality standards. Our painters are trained in working within the constraints of apartment buildings, including limited access, shared spaces, and the need for quiet working hours.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Apartment and Multi-Unit Residential Expertise</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  De Waterkant is predominantly composed of apartment buildings and multi-unit residential complexes, many of which are converted heritage buildings. We specialize in painting services for these unique properties, understanding the specific requirements of apartment living including body corporate regulations, shared access areas, and the need for coordinated scheduling with multiple residents. Our team is experienced in working with property managers, homeowners associations, and individual apartment owners to ensure smooth project execution that meets everyone's needs and expectations.
                </p>
                
                <p className="text-gray-700 leading-relaxed mb-6">
                  We offer comprehensive painting solutions for apartment interiors, from single rooms to complete apartment renovations. Our painters are skilled in working efficiently in compact urban spaces, protecting furniture and belongings, and maintaining clean work areas throughout the project. We use premium low-VOC paints that are safe for occupied buildings and dry quickly to minimize disruption. Our color consultation services help apartment owners choose the perfect palette that maximizes natural light and creates the illusion of space in smaller urban living areas.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Heritage Property Restoration and Preservation</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Many buildings in De Waterkant are heritage properties with significant historical value, requiring specialized knowledge and techniques for proper restoration and maintenance. Our team has extensive experience in heritage property painting, understanding the importance of preserving original architectural features while updating finishes to meet modern standards. We work closely with heritage consultants and follow strict guidelines to ensure all work respects the historical integrity of these important buildings while providing durable, beautiful results.
                </p>
                
                <p className="text-gray-700 leading-relaxed mb-6">
                  Heritage restoration requires careful surface preparation, the use of appropriate materials that are compatible with original construction methods, and attention to period-appropriate color schemes and finishes. We have access to specialized paints and coatings designed specifically for heritage buildings, including breathable masonry paints that allow moisture to escape while protecting against weather damage. Our painters are trained in traditional techniques as well as modern methods, ensuring we can handle any heritage restoration project with the care and expertise it deserves.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Commercial Space Transformation</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  De Waterkant has become a hub for creative businesses, tech startups, and trendy restaurants and cafes. We provide professional painting services for commercial spaces, understanding the unique requirements of business environments including the need for minimal disruption to operations, adherence to strict timelines, and finishes that reflect brand identity and create the right atmosphere for customers and employees. Our commercial painting services include offices, retail spaces, restaurants, galleries, and other business premises throughout De Waterkant and surrounding areas.
                </p>
                
                <p className="text-gray-700 leading-relaxed mb-6">
                  We work closely with business owners, interior designers, and architects to bring commercial design visions to life. Our team is experienced in applying specialized finishes including feature walls, decorative techniques, and custom color matching to create unique spaces that stand out in Cape Town's competitive business environment. We understand the importance of completing commercial projects on schedule and within budget, and our project management approach ensures clear communication and efficient execution from start to finish.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Quality Materials for Urban Environments</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Urban environments like De Waterkant present specific challenges including pollution, moisture from proximity to the ocean, and high foot traffic in common areas. We exclusively use premium paints and coatings specifically formulated to withstand these urban conditions while maintaining their appearance and integrity over time. Our paint selection includes leading brands known for their durability, washability, and resistance to fading and staining. For interior spaces, we prioritize low-VOC and environmentally friendly products that are safe for occupied buildings and contribute to healthy indoor air quality.
                </p>
                
                <p className="text-gray-700 leading-relaxed mb-8">
                  For exterior painting projects, we use weather-resistant coatings that protect against Cape Town's variable climate while providing excellent color retention and resistance to urban pollution. Our waterproofing and damp-proofing solutions are particularly important in De Waterkant's older buildings, where moisture management is crucial for maintaining structural integrity and preventing damage. We conduct thorough assessments before beginning any project to identify potential issues and recommend appropriate solutions that will ensure long-lasting results.
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Our Specialties</h3>
                    <div className="flex flex-wrap gap-2">
                      {painter.specialties.map((specialty, index) => (
                        <span key={index} className="bg-lime-100 text-lime-800 px-3 py-1 rounded-full text-sm font-medium">
                          {specialty}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Service Areas</h3>
                    <div className="space-y-2">
                      {painter.serviceAreas.slice(0, 4).map((area, index) => (
                        <div key={index} className="flex items-center text-gray-700">
                          <i className="ri-map-pin-line mr-2 text-lime-500"></i>
                          {area}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              
              <div>
                <div className="bg-gray-50 p-6 rounded-lg sticky top-6">
                  <div className="mb-6">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20stylish%20urban%20apartment%20in%20De%20Waterkant%20Cape%20Town%2C%20trendy%20neighborhood%20with%20Signal%20Hill%20backdrop%2C%20painters%20in%20clean%20uniforms%20with%20quality%20equipment%2C%20contemporary%20architecture%2C%20bright%20natural%20lighting&width=400&height=300&seq=dewaterkant-sidebar-image&orientation=landscape"
                      alt="Professional painters De Waterkant apartment painting services Cape Town urban properties"
                      className="w-full h-48 object-cover object-top rounded-lg"
                    />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">Quick Contact</h3>
                  <div className="space-y-4">
                    <div className="flex items-center">
                      <i className="ri-mail-line mr-3 text-lime-500"></i>
                      <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                        {painter.email}
                      </a>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-global-line mr-3 text-lime-500"></i>
                      <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                        Visit Website
                      </a>
                    </div>
                  </div>
                  
                  <button 
                    onClick={() => navigate('/quote')}
                    className="w-full mt-6 bg-lime-400 text-black py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Get Free Quote
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'services' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Comprehensive Painting Services in De Waterkant</h2>
              
              <div className="mb-12">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">Urban Residential and Commercial Painting</h3>
                <p className="text-gray-700 mb-8 leading-relaxed">
                  Our painting services are specifically designed for the unique requirements of De Waterkant's urban environment. From apartment interiors to heritage building exteriors and commercial spaces, we provide comprehensive solutions that combine quality craftsmanship with efficient project management and minimal disruption to your daily life or business operations.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
                {painter.services.map((service, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow">
                    <div className="flex items-center mb-4">
                      <i className="ri-brush-line text-2xl text-lime-500 mr-3"></i>
                      <h3 className="text-lg font-semibold text-gray-900">{service}</h3>
                    </div>
                    <p className="text-gray-600">Professional {service.toLowerCase()} services with premium materials and expert urban application techniques.</p>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">Interior Painting Excellence</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Our interior painting services transform De Waterkant apartments and commercial spaces into beautiful, functional environments. We use premium low-VOC paints that are safe for occupied buildings and provide excellent coverage and durability. Our color consultation services help you choose the perfect palette that complements your urban lifestyle and maximizes the impact of natural light in your space.
                  </p>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    We understand the challenges of painting in occupied apartment buildings and work efficiently to minimize disruption. Our team is experienced in protecting furniture and belongings, maintaining clean work areas, and coordinating with building management to ensure smooth project execution. We can work in stages if needed to accommodate your schedule and ensure you can continue living or working in your space during the painting process.
                  </p>
                </div>
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">Exterior and Heritage Restoration</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Exterior painting in De Waterkant requires specialized knowledge of heritage architecture and urban environmental conditions. We use premium paints and protective coatings that resist pollution, moisture, and weather damage while respecting the historical character of heritage buildings. Our comprehensive exterior painting process includes thorough surface preparation, appropriate primer application, and multiple coats of premium paint for maximum protection and longevity.
                  </p>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    For heritage properties, we work closely with heritage consultants and follow strict preservation guidelines to ensure all work maintains the historical integrity of these important buildings. We have access to specialized materials and traditional techniques that are appropriate for heritage restoration while providing modern durability and protection. Our waterproofing and damp-proofing services are particularly important for older buildings, helping to prevent moisture damage and extend the life of your property.
                  </p>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'gallery' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Recent Painting Projects in De Waterkant</h2>
              <p className="text-gray-700 mb-12 leading-relaxed">
                Explore our portfolio of recent painting projects throughout De Waterkant and surrounding urban areas. Each project demonstrates our commitment to quality workmanship and our expertise in urban residential, heritage, and commercial painting applications.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {painter.gallery.map((image, index) => (
                  <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                    <img 
                      src={image} 
                      alt={`${painter.name} project ${index + 1}`}
                      className="w-full h-64 object-cover object-top"
                    />
                    <div className="p-4">
                      <h3 className="font-semibold text-gray-900 mb-2">De Waterkant Project {index + 1}</h3>
                      <p className="text-gray-600 text-sm">Professional urban painting with premium materials and expert application techniques.</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'reviews' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Customer Reviews and Testimonials</h2>
              <p className="text-gray-700 mb-12 leading-relaxed">
                Read what our satisfied customers throughout De Waterkant have to say about our painting services. Our commitment to excellence and customer satisfaction is reflected in these genuine reviews from apartment owners, property managers, and business owners in the area.
              </p>
              
              <div className="space-y-6">
                {painter.testimonials.map((testimonial, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg p-6">
                    <div className="flex items-center mb-4">
                      <div className="flex items-center">
                        {[...Array(5)].map((_, i) => (
                          <i key={i} className={`ri-star-fill ${i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                        ))}
                      </div>
                      <span className="ml-3 font-semibold text-gray-900">{testimonial.name}</span>
                    </div>
                    <p className="text-gray-700 leading-relaxed">{testimonial.comment}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'contact' && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Contact Painters De Waterkant</h2>
                <p className="text-gray-700 mb-8 leading-relaxed">
                  Ready to transform your De Waterkant property with professional painting services? Contact us today for a free consultation and quote. We're here to help you achieve beautiful, long-lasting results that enhance your urban lifestyle.
                </p>
                
                <div className="space-y-6">
                  <div className="flex items-center">
                    <i className="ri-mail-line text-2xl text-lime-500 mr-4"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Email</h3>
                      <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                        {painter.email}
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <i className="ri-global-line text-2xl text-lime-500 mr-4"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Website</h3>
                      <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                        {painter.website}
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <i className="ri-map-pin-line text-2xl text-lime-500 mr-4 mt-1"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Service Area</h3>
                      <p className="text-gray-700">{painter.location} and surrounding urban areas</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Get Your Free Quote Today</h3>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  Request a free, no-obligation quote for your De Waterkant painting project. Our experienced team will assess your property and provide detailed recommendations tailored to urban living requirements.
                </p>
                <button 
                  onClick={() => navigate('/quote')}
                  className="w-full bg-lime-400 text-black py-4 rounded-lg font-semibold hover:bg-lime-500 transition-colors text-lg whitespace-nowrap cursor-pointer"
                >
                  Request Free Quote
                </button>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
